// Calendar workspace status labels (Issue #171).
// Kept feature-local so /tasks list retains its own wording.

export const CALENDAR_STATUS_LABELS = {
  todo: "Заплановано",
  in_progress: "В роботі",
  done: "Виконано",
  cancelled: "Скасовано",
};

export const CALENDAR_STATUS_OPTIONS = [
  { value: "todo", label: CALENDAR_STATUS_LABELS.todo },
  { value: "in_progress", label: CALENDAR_STATUS_LABELS.in_progress },
  { value: "done", label: CALENDAR_STATUS_LABELS.done },
  { value: "cancelled", label: CALENDAR_STATUS_LABELS.cancelled },
];

export const getCalendarStatusLabel = (status) =>
  CALENDAR_STATUS_LABELS[status] || "Невідомий статус";
